<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
import AddShip2DbDialog from './AddShip2DbDialog.vue';
export default {
  name: 'ShipSelect',
  components: {
    MSelectPulldown,
    AddShip2DbDialog
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    },
    enableShipxy: {
      type: Boolean,
      default: true
    },
    dispatchFlag: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 50,
        total: 0
      },
      field: {
        value: 'id',
        label: 'name'
      },

      keyword: '',
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onBeforeItemChecked(checkedItem) {
      if (Object.keys(checkedItem).length > 0 && !checkedItem._x_isDb) {
        this.onAddDb(checkedItem)
        return false
      }
      return true
    },
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
      this.$emit('update:shipName', checkedItem.name)
      this.$emit('update:shipType', checkedItem.shipType)
    },
    async loadData(keyword) {
      try {
        const { page, size } = this.page;
        const params = {
          ...this.queryParams,
          page,
          size,
          keyword: keyword,
          enableShipxy: this.enableShipxy ? 1 : 0,
          dispatchFlag: this.dispatchFlag
        };
        const res = await this.$store.dispatch('bu_ship/fetchOptions', params);
        let records = res.data.records || [];
        records.forEach(item => {
          item._x_isDb = !!item.id
        })
        // 更新分页总数
        this.page.total = res.data.total;
        return {
          data: records
        };
      } catch (err) {
        console.error('加载船舶数据失败:', err);
        throw err;
      }
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
      this.keyword = keyword
    },
    async fetchObject(value) {
      return await this.$store.dispatch('bu_ship/fetchObject', value);
    },
    onAddDb(item) {
      this.$refs.pulldown.$refs.xDown._x_hidePanel = this.$refs.pulldown.$refs.xDown.hidePanel
      this.$refs.pulldown.$refs.xDown.hidePanel = () => {}
      this.$refs.addShip2DbDialog.open(Object.assign({}, item, {
        name: this.keyword || item.name
      }))
    },
    onAddDbComplete(item) {
      this.$store.dispatch('bu_ship/clearCache');
      this.$refs.pulldown.onQuery(true)
      this.onItemChecked(item)
    },
    onAddDbClose() {
      this.$refs.pulldown.$refs.xDown.hidePanel = this.$refs.pulldown.$refs.xDown._x_hidePanel
    },
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="field"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    :on-before-item-checked="onBeforeItemChecked"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item padding-sm cursor"
        :class="{
          'active': item._x_isDb && item.id === localValue && !localValue,
          'warning': !item._x_isDb
        }"
        @click="$refs.pulldown.onItemChecked(item)"
      >
        <div class="flex justify-between">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.name }}</span>
            <span v-if="!item._x_isDb" class="text-xs" style="display: inline-block;margin-left: 10px;color: var(--color-warning);">未在船舶数据库中</span>
          </div>
          <div style="white-space: nowrap;">
            <template v-if="item._x_isDb">
              <span class="label">载重吨：</span>
              <span>{{ item.deadweightTons }}</span>
            </template>
            <template v-else>
              <span class="label">MMSI：</span>
              <span>{{ item.mmsi }}</span>
            </template>
          </div>
        </div>
        <div class="flex justify-between margin-top-xs">
          <div>
            <template v-if="item._x_isDb">
              <span class="label">船老大/联系方式：</span>
              <span>{{ item.shipownerName || '-' }} / {{ item.shipownerContact || '-' }}</span>
            </template>
            <template v-else>
              <el-button type="text" icon="el-icon-plus">维护船舶</el-button>
            </template>
          </div>
          <div style="white-space: nowrap;">
            <template v-if="item._x_isDb">
              <span class="label">船长/宽：</span>
              <span>{{ item.shipLength }}/{{ item.shipBreadth }}</span>
            </template>
            <template v-else>
              <span class="label">更新时间：</span>
              <span>{{ item.lastUpdateTime || '-' }}</span>
            </template>
          </div>
        </div>
      </div>
      <add-ship-2-db-dialog ref="addShip2DbDialog" @close="onAddDbClose" @complete="onAddDbComplete" />
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
.item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
  &.warning {
    background: var(--color-warning-light-1);
  }
}
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
